export enum BorderStyle {
  GreyThinSolid,
  BlackThickSolid,
  BlackThinSolid,
  None,
}
